export default __webpack_public_path__ + "static/media/41_desktop.fd97d4ee.jpg";